import { useCallback } from 'react';
import { App } from 'antd';

export const useCopyToClipboard = () => {
  const { message } = App.useApp();

  const copyToClipboard = useCallback((value: string) => {
    const handleCopy = async () => {
      try {
        if (navigator?.clipboard?.writeText) {
          await navigator.clipboard.writeText(value);
          message.success('Copied!');
        } else {
          throw new Error('writeText not supported');
        }
      } catch (e) {
        console.log('Copy to clipboard failed', e);
      }
    };

    handleCopy();
  }, []);

  return copyToClipboard;
};
